import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { LoadingService } from '../../core/loading/loading.service';
import { setLocaleDayOfWeek } from 'ngx-bootstrap/chronos/units/day-of-week';

@Component({
    template: `
        <i *ngIf="!text && !isLoading" class="{{cursorClass}} fa {{icon}} {{color}}"
          (click)="onClick()" ngbTooltip="{{title}}" placement="right"></i>
        <button *ngIf="text && !isLoading" type="button" class="btn btn-sm {{color}}" [disabled]="isDisabled"
          (click)="onClick()" ngbTooltip="{{title}}" placement="right">{{text}}</button>
      <i *ngIf="isLoading" class="fa fa-spinner fa-spin fa-fw"></i>
    `,
})
export class CustomButtonCellComponent<T> implements OnInit, OnDestroy {

    constructor(private changeDetectorRef: ChangeDetectorRef, private loadingService: LoadingService) { }

    icon = 'fa-plus-circle';
    color = 'text-primary';
    showLoading = false;
    isLoading = false;
    title: string;
    customTitle: string;
    customInput: string;
    disableInput: string;
    isDisabled = false;
    text: string;
    cursorClass = 'pointer';
    avoidClick = false;

    @Input() rowData: T ;

  /*eslint-disable */ @Output() click = new EventEmitter<{ data: any, done: () => void }>(); /*eslint-enable */

    ngOnInit(): void {
        const data: any = this.rowData;
      console.log('else: ', { data });
        if ((this.rowData[this.customInput] === undefined || this.rowData[this.customInput] === null) &&
            (this.rowData[this.disableInput] === undefined || this.rowData[this.disableInput] === null)) {
            this.title = null;
            this.isDisabled = false;
        } else if (!(this.rowData[this.customInput] === undefined || this.rowData[this.customInput] === null)) {
            this.title = this.customTitle;
            this.isDisabled = this.rowData[this.customInput];
        } else if (!(this.rowData[this.disableInput] === undefined || this.rowData[this.disableInput] === null)) {
            this.isDisabled = this.rowData[this.disableInput];
            this.title = 'Hay un error en el formulario';
        } else {
            this.isDisabled = false;
            this.title = null;
        }

        if (!data?.cc) {
          this.title = 'Orden sin centro de costo';
          this.isDisabled = true;
        }

        if (this.isDisabled) {
            this.avoidClick = true;
            this.cursorClass = 'btn disabled no-pointer';
        } else {
            this.cursorClass = 'pointer';
            this.avoidClick = false;
            this.title = null;
        }
    }

    ngOnDestroy(): void {
        this.changeDetectorRef.detach();
    }

    onClick(): void {
        if (this.avoidClick) {
            return;
        }
        if (this.isDisabled) {
            return;
        }

        const self = this;
        this.click.emit({

            data: self.rowData,
            done: () => {

                if (!self.changeDetectorRef['destroyed']) {
                    self.changeDetectorRef.detectChanges();
                }

            }
        });

    }

}
